import { GeneratedDocument, GeneratedDocumentStatus, GeneratedDocumentType } from './generatedDocumentsApiTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockGetGeneratedDocuments: GeneratedDocument[] = [
  {
    id: 1,
    type: GeneratedDocumentType.LISTING_REPORT_EXPORT,
    status: GeneratedDocumentStatus.COMPLETED,
    title: 'Allegro All offers 10.04.2026 08-12-00',
    errorMessage: null,
    createdAt: '2026-04-10T08:12:00',
    completedAt: '2026-04-10T08:13:42',
    url: '/Allegro All offers 14.04.2026 15-04-00.xlsx',
  },
  {
    id: 2,
    type: GeneratedDocumentType.LISTING_REPORT_EXPORT,
    status: GeneratedDocumentStatus.PROCESSING,
    title: 'Allegro All offers 14.04.2026 15-04-00',
    errorMessage: null,
    createdAt: '2026-04-14T15:04:00',
    completedAt: null,
    url: null,
  },
  {
    id: 3,
    type: GeneratedDocumentType.LISTING_REPORT_EXPORT,
    status: GeneratedDocumentStatus.CREATED,
    title: 'Allegro All offers 15.04.2026 09-30-00',
    errorMessage: null,
    createdAt: '2026-04-15T09:30:00',
    completedAt: null,
    url: null,
  },
  {
    id: 4,
    type: GeneratedDocumentType.LISTING_REPORT_EXPORT,
    status: GeneratedDocumentStatus.FAILED,
    title: 'Allegro All offers 09.04.2026 07-00-00',
    errorMessage: 'Generation failed due to storage timeout',
    createdAt: '2026-04-09T07:00:00',
    completedAt: null,
    url: null,
  },
];
